import React, { useEffect, useState } from 'react';
import { Minus, Plus, Sparkles } from 'lucide-react';
import { getProducts } from '../lib/api';
import { useCart } from '../context/CartContext';

export const KitNudge = () => {
  const [kit, setKit] = useState(null);
  const { items, addToCart, updateQty } = useCart();

  useEffect(() => {
    let active = true;
    getProducts()
      .then((all) => {
        if (!active) return;
        const k = (all || []).find((p) => p.code === 'KIT10' && !p.hidden);
        setKit(k || null);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!kit || kit.stockStatus === 'Out of Stock') return null;
  const inCart = items.find((i) => i.id === kit.id);
  const qty = inCart?.qty || 0;

  return (
    <div className="glass-card rounded-lg p-3.5 mb-5 flex items-center gap-3" data-testid="kit-nudge">
      <img src={kit.image} alt={kit.name} className="w-12 h-12 object-cover rounded bg-alp-dark shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-alp-cream text-sm font-medium leading-snug flex items-center gap-1.5">
          <Sparkles size={12} className="text-alp-gold shrink-0" /> {kit.name}
        </p>
        <p className="text-alp-gray text-[11px] mt-0.5">{kit.size} &middot; <span className="text-alp-gold">${kit.price.toFixed(2)}</span> &middot; every order includes 4 wipes + 4 syringes free; BAC water additional</p>
      </div>
      {qty === 0 ? (
        <button
          onClick={() => addToCart(kit, 1)}
          data-testid="kit-nudge-add"
          className="shrink-0 inline-flex items-center gap-1 text-[10px] tracking-[0.15em] uppercase bg-alp-gold text-alp-black px-3 py-2 rounded font-semibold hover:bg-alp-goldlight transition-colors"
        >
          <Plus size={12} /> Add
        </button>
      ) : (
        <div className="shrink-0 flex items-center border border-alp-gold/40 rounded">
          <button onClick={() => updateQty(kit.id, qty - 1)} data-testid="kit-nudge-minus" className="w-8 h-8 flex items-center justify-center text-alp-cream hover:text-alp-gold transition-colors"><Minus size={13} /></button>
          <span className="w-7 text-center text-sm text-alp-gold" data-testid="kit-nudge-qty">{qty}</span>
          <button onClick={() => updateQty(kit.id, qty + 1)} data-testid="kit-nudge-plus" className="w-8 h-8 flex items-center justify-center text-alp-cream hover:text-alp-gold transition-colors"><Plus size={13} /></button>
        </div>
      )}
    </div>
  );
};

export default KitNudge;
